import { useEffect } from "react";

export const useTextReplacer = () => {
  useEffect(() => {
    // Для предотвращения мигания
    const style = document.createElement("style");
    style.textContent = `
      [data-component="text"] {
        visibility: hidden !important;
      }
      [data-component="text"].text-processed {
        visibility: visible !important;
      }
    `;
    document.head.appendChild(style);

    const processTextElements = () => {
      const textElements = document.querySelectorAll(
        '[data-component="text"]:not(.text-processed)',
      );
      textElements.forEach((el) => {
        if (el.textContent?.includes("More")) {
          el.innerHTML = el.innerHTML.replace("More", "Еще");
        }
        el.classList.add("text-processed");
      });
    };

    // Обработать элементы, отрендеренные до подключения observer
    processTextElements();

    const observer = new MutationObserver(processTextElements);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      document.head.removeChild(style);
    };
  }, []);
};
